import {APIClient} from "../utils/APIClient.js";
import CryptoJS from "crypto-js"

export default function useAuth() {

  const getUser = async () => {
      return await APIClient().getLoggedUser();
  }

  const logout = async () => {
      await APIClient().logout();
      window.location.href = '/';
  }

  const login = async (username, password) => {
      if (username && password) {
          const passwordSha256 = CryptoJS.SHA256(password);
          const passwordHex = passwordSha256.toString(CryptoJS.enc.Hex);
          const user = await APIClient().login(username, passwordHex);
          return user;
      }
  }

  return {
    login,
    logout,
    getUser,
  }
}
